import React from 'react'
import { makeStyles } from '@material-ui/core'
import HMapDisplayTabHeader from './HMapDisplayTabHeader'
import HMapDisplayTabContent from './HMapDisplayTabContent'
import { HMapTabs } from '../../const/HMapTabs'
import { useHMapContext } from '../../hooks/useHMapContext'

const HMapDisplayTabs = ({ setCurrentPanel }) => {
  const classes = useStyles()
  const { allHeatMapsList, currentTabInfo } = useHMapContext()
  const [allHeatMaps, setAllHeatMaps] = allHeatMapsList
  const [currentTab, setCurrentTab] = currentTabInfo

  return (
    <div className={classes.root}>
      <HMapDisplayTabHeader
        currentTab={currentTab}
        setCurrentTab={setCurrentTab}
        setCurrentPanel={setCurrentPanel}
        HMapTabs={HMapTabs}
        allHeatMaps={allHeatMaps}
      />
      <HMapDisplayTabContent
        currentTab={currentTab}
        HMapTabs={HMapTabs}
        setCurrentPanel={setCurrentPanel}
        allHeatMaps={allHeatMaps}
        setAllHeatMaps={setAllHeatMaps}
      />
    </div>
  )
}

export default React.memo(HMapDisplayTabs)

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    opacity: 'inherit'
  }
}))
